<template>
	
<core-card-foot-date :value="value" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return (this.item.collection) ? this.item.collection.dates.updated : false

		}

	}

}

</script>

<style scoped>

</style>
